import {
  NodeSearchActionTypes,
  NodeSearchActions,
} from './node-search.actions';
import {
  NODE_SEARCH_INITIAL_STATE,
  NodeSearchState,
} from './nodes-editor.state';

export function nodeSearchReducer(
  state: NodeSearchState = NODE_SEARCH_INITIAL_STATE,
  action: NodeSearchActions,
): NodeSearchState {
  switch (action.type) {
    case NodeSearchActionTypes.NODE_SEARCH_CLEARED: {
      return NODE_SEARCH_INITIAL_STATE;
    }

    case NodeSearchActionTypes.NODE_SEARCH_INITIATED: {
      return {
        error: null,
        isLoading: true,
        searchResults: null,
        searchTerm: action.payload.searchTerm,
      };
    }

    case NodeSearchActionTypes.NODE_SEARCH_RESULTS_LOADED: {
      const { searchTerm, results } = action.payload;

      if (searchTerm !== state.searchTerm) {
        // We've moved on to a new search, so don't modify state
        return state;
      }

      return {
        error: null,
        isLoading: false,
        searchResults: results,
        searchTerm,
      };
    }

    case NodeSearchActionTypes.NODE_SEARCH_FAILED: {
      const { searchTerm, error } = action.payload;

      if (searchTerm !== state.searchTerm) {
        // We've moved on to a new search, so don't modify state
        return state;
      }

      return {
        error,
        isLoading: false,
        searchResults: null,
        searchTerm,
      };
    }

    default: {
      return state;
    }
  }
}
